'use client'

import { useLocalStorage, useReadLocalStorage } from 'usehooks-ts'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { useEffect, useState } from 'react'

export function CookiesConsent() {
  const [consentedCookies, setConsentedCookies] = useState('')
  const [hasConsentedCookies, setHasConsentedCookies] = useLocalStorage(
    'accepts-cookies',
    'false',
  )

  useEffect(() => {
    setConsentedCookies(hasConsentedCookies)
  }, [hasConsentedCookies])

  if (consentedCookies === 'false')
    return (
      <Card className='w-sm fixed bottom-2 left-2 z-50'>
        <CardHeader>
          <CardTitle>Aviso de privacidad y cookies</CardTitle>
          <CardDescription>
            Al continuar utilizando nuestros servicios, aceptas el uso de
            cookies para optimizar tu experiencia, analítica de datos y
            seguridad en la plataforma.
          </CardDescription>
        </CardHeader>
        <CardFooter className='flex justify-end'>
          <Button
            variant='default'
            onClick={() => setHasConsentedCookies('true')}
            className='bg-indigo-500'
          >
            Entendido
          </Button>
        </CardFooter>
      </Card>
    )

  return null
}
